// extracted by mini-css-extract-plugin
export var checkbox = "style-module--checkbox--f70b3";
export var checkboxLabel = "style-module--checkboxLabel--fd7b1";
export var checkboxRow = "style-module--checkboxRow--3a245";